import { Brands } from '@/components/brand/Brands'
import Account from '@/components/Account'
import AuthCallback from '@/components/public/auth/AuthCallback'
import LinkedInCallback from '@/components/auth/LinkedInCallback'
import TwitterCallback from '@/components/auth/TwitterCallback'
import InstagramCallback from '@/components/auth/InstagramCallback'
import ProcessInvitation from '@/components/public/auth/process-invitation'
import Convergences from '@/components/convergences/convergences'
import ConvergenceFeed from '@/components/convergences/ConvergenceFeed'
import { ConvergenceDetail } from '@/components/convergence/ConvergenceDetail'
import { BrandGenius } from '@/components/brand/BrandGenius'
import { BrandSettings } from '@/components/brand/BrandSettings'
import BrandResources from '@/components/brand/BrandResources'
import { BrandGuide } from '@/components/brand/BrandGuide'
import BrandTheme from '@/components/brand/BrandTheme'
import BrandAnalysisView from '@/components/brand/BrandAnalysisView'
import { PlatformConnections } from '@/components/brand/PlatformConnections'
import { PlatformSettings } from '@/components/brand/PlatformSettings'
import { RssFeedViewer } from '@/components/brand/RssFeedViewer'
import InternalBlogList from '@/components/brand/InternalBlogList'
import InternalBlogPost from '@/components/brand/InternalBlogPost'
import { BrandConsultant } from '@/components/brand-consultant/BrandConsultant'
import CampaignsScreen from '@/components/campaigns/CampaignsScreen'
import { CampaignDetails } from '@/components/campaigns/CampaignDetails'
import { NewCampaign } from '@/components/campaigns/NewCampaign'
import ContentManagement from '@/components/content/ContentManagement'
import ContentTypeSelection from '@/components/content/ContentTypeSelection'
import ContentDetails from '@/components/content/ContentDetails'
import Profile from '@/components/profile/Profile'
import AdminConsole from '@/components/admin/AdminConsole'
import { Session } from '@supabase/supabase-js';
import { ReactElement, ComponentType } from 'react'
import { EditCampaign } from '@/components/campaigns/EditCampaign'
import SettingsPage from "@/components/settings/SettingsPage"
import PurchaseSuccess from "../components/settings/PurchaseSuccess"
import { Dashboard } from "@/components/Dashboard"
import LogoutPage from '@/components/auth/LogoutPage'
import SubscriptionSettings from '@/components/settings/SubscriptionSettings'
import BillingSettings from '@/components/settings/BillingSettings'
import AcceptInvitation from '@/components/settings/AcceptInvitation'
import { AcceptBrandInvitation } from '@/components/invitations/AcceptBrandInvitation'
import { ProtectedTeamManagement } from '@/components/settings/TeamManagement'
import Help from '@/components/help/Help'
import { FeatureUpgradePage } from '@/components/plan/FeatureUpgradePage'
import { CreditUsageDashboard } from '@/components/billing/CreditUsageDashboard'
import { Credits } from '@/components/credits/Credits'
import Automation from '@/components/automation/Automation'

export type RouteType = {
  path: string;
  element: ComponentType<any> | (() => ReactElement) | ((props: { session: Session }) => ReactElement);
};

// Let's create a feature-protected wrapper for the TeamManagement page
// Since we can't use JSX in .ts files, we'll create a wrapper component in TeamManagement.tsx

export const routes: RouteType[] = [
  { path: '/brands', element: Brands },
  { path: '/brands/:id', element: BrandGenius },
  { path: '/brands/:id/analysis', element: BrandAnalysisView },
  { path: '/brands/:id/consultant', element: BrandConsultant },
  { path: '/brands/:id/settings', element: BrandSettings },
  { path: '/brands/:id/resources', element: BrandResources },
  { path: '/brands/:id/theme', element: BrandTheme },
  { path: '/brands/:id/connections', element: PlatformConnections },
  { path: '/brands/:id/connections/:platformId/settings', element: PlatformSettings },
  { path: '/brands/:id/rss-feed', element: RssFeedViewer },
  { path: '/brands/:id/blog', element: InternalBlogList },
  { path: '/brands/:id/blog/:postId', element: InternalBlogPost },
  { path: '/feed', element: ConvergenceFeed },
  { path: '/convergences', element: Convergences },
  { path: '/convergences/:id', element: ConvergenceDetail },
  { path: '/campaigns', element: CampaignsScreen },
  { path: '/campaigns/new', element: NewCampaign },
  { path: '/campaigns/:id', element: CampaignDetails },
  { path: '/campaigns/:id/edit', element: EditCampaign },
  { path: '/content', element: ContentManagement },
  { path: '/content/create', element: ContentTypeSelection },
  { path: '/content/:id', element: ContentDetails },
  { path: '/content/:id/improve', element: ContentDetails },
  { path: '/social-platform-automation', element: PlatformConnections },
  { path: '/dashboard', element: Dashboard },
  { path: '/profile', element: Profile },
  { path: '/account', element: Account },
  { path: '/auth/callback', element: AuthCallback },
  { path: '/auth/linkedin/callback', element: LinkedInCallback },
  { path: '/auth/twitter/callback', element: TwitterCallback },
  { path: '/auth/instagram/callback', element: InstagramCallback },
  { path: '/admin', element: AdminConsole },
  { path: '/brand-genius', element: BrandGenius },
  { path: '/brand/settings', element: BrandSettings },
  { path: '/brand/resources', element: BrandResources },
  { path: '/brand/theme', element: BrandTheme },
  { path: '/brand/guide', element: BrandGuide },
  { path: '/settings', element: SettingsPage },
  { path: '/settings/subscription', element: SubscriptionSettings },
  { path: '/settings/billing', element: BillingSettings },
  { path: '/settings/billing/credits', element: CreditUsageDashboard },
  { path: '/settings/team', element: ProtectedTeamManagement },
  { path: '/credits', element: Credits },
  { path: '/purchase-success', element: PurchaseSuccess },
  { path: '/checkout/success', element: PurchaseSuccess },
  { path: '/logout', element: LogoutPage },
  { path: '/help', element: Help },
  { path: '/automation', element: Automation },
  { path: '/invitations/accept', element: AcceptInvitation },
  { path: '/invitations/brand/:token', element: AcceptBrandInvitation },
  { path: '/process-invitation', element: ProcessInvitation },
  { path: '/plan-upgrade/:featureName', element: FeatureUpgradePage },
  // default to dashboard
  { path: '/', element: Dashboard }
]
